import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChartBarIcon } from '@phosphor-icons/react';
import { ConfidenceFilter, Tag } from '@/components';
import { ChipPopover } from './ChipPopover';
import type { ConfidenceFilter as ConfidenceFilterType } from '@/utils/query-filters';

interface ConfidenceFilterChipProps {
    onApply: (range: { min: number; max: number }) => void;
    confidence: ConfidenceFilterType;
    tagVariant?: 'base' | 'plain';
}

export function ConfidenceFilterChip({
    onApply,
    confidence,
    tagVariant = 'base',
}: ConfidenceFilterChipProps) {
    const { t } = useTranslation();
    const [popoverOpen, setPopoverOpen] = useState(false);
    const confidenceLabel = t('confidenceFilter.chipLabel', {
        min: confidence.min,
        max: confidence.max,
    });

    return (
        <ChipPopover
            popoverOpen={popoverOpen}
            onPopoverOpenChange={setPopoverOpen}
            chip={
                <Tag
                    data-testid="filter-chip-confidence"
                    variant={tagVariant}
                    size="sm"
                    leadingIcon={<ChartBarIcon weight="fill" />}
                    onClick={() => setPopoverOpen((prev) => !prev)}
                >
                    {confidenceLabel}
                </Tag>
            }
        >
            <ConfidenceFilter
                min={confidence.min}
                immediatelyApply
                onApply={onApply}
                onClose={() => setPopoverOpen(false)}
            />
        </ChipPopover>
    );
}
